module.exports = __webpack_public_path__ + "media/images/icon_print-7067289604847d2774dfcfcea03ae3b7.png";